import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import ProductTypes from '../components/product-types'

import useScreen from '../hooks/use-screen'

const ProductRootPage = ({ pageContext }) => {
  const screen = useScreen()
  const { types, lang, sitePrefix, siteTitle } = pageContext

  return (
    <Layout {...pageContext }>
      <SEO title={siteTitle} lang={lang} />
      <ProductTypes
        sitePrefix={sitePrefix}
        showTitle={false}
        gutter={true}
        screen={screen}
        types={types}
      />
    </Layout>
  )
}

export default ProductRootPage
